<!--
 * @Author: Junchi Zhao
 * @LastEditors: Junchi Zhao
 * @Description:  溯源信息
-->
<template>
  <div class="info">
    <div class="left w14 fg1">
      <div class="bg">
        <div class="code">追溯码：{{ $route.query.code }}</div>
      </div>
    </div>
    <div class="right w14 fg1" v-if="!showSdsy">
      <!-- 顶部tab栏 -->
      <div class="searchInfo">
        <div
          class="tab"
          style="border-radius:10px 0px 0px 0px;"
          :class="{ active: active === 1 }"
          @click="active = 1"
        >
          <img
            v-show="active === 1"
            src="../../../assets/images/sy/cpxx_active.svg"
            alt=""
          />
          <img
            v-show="active !== 1"
            src="../../../assets/images/sy/cpxx.svg"
            alt=""
          />
          <div>产品信息</div>
        </div>
        <div class="tab" :class="{ active: active === 2 }" @click="active = 2">
          <img
            v-show="active === 2"
            src="../../../assets/images/sy/qyxx_active.svg"
            alt=""
          />
          <img
            v-show="active !== 2"
            src="../../../assets/images/sy/qyxx.svg"
            alt=""
          />
          <div>企业信息</div>
        </div>
        <div class="tab" :class="{ active: active === 3 }" @click="active = 3">
          <img
            v-show="active === 3"
            src="../../../assets/images/sy/cdxx_active.svg"
            alt=""
          />
          <img
            v-show="active !== 3"
            src="../../../assets/images/sy/cdxx.svg"
            alt=""
          />
          <div>产地信息</div>
        </div>
        <div class="tab" :class="{ active: active === 4 }" @click="active = 4">
          <img
            v-show="active === 4"
            src="../../../assets/images/sy/sdsy_active.svg"
            alt=""
          />
          <img
            v-show="active !== 4"
            src="../../../assets/images/sy/sdsy.svg"
            alt=""
          />
          <div>深度溯源</div>
        </div>
        <div
          class="tab"
          style="border-radius:0px 10px 0px 0px;"
          :class="{ active: active === 5 }"
          @click="active = 5"
        >
          <img
            v-show="active === 5"
            src="../../../assets/images/sy/pzbz_active.svg"
            alt=""
          />
          <img
            v-show="active !== 5"
            src="../../../assets/images/sy/pzbz.svg"
            alt=""
          />
          <div>品质保证</div>
        </div>
      </div>
      <div class="ova mb30" style="border-radius:0px 0px 10px 10px;">
        <!-- 产品信息 -->
        <div class="content" v-show="active === 1">
          <el-row>
            <dataInfo :number="12" name="品种介绍" :value="cpjs"></dataInfo>
            <dataInfo :number="12" name="产地" >鄂温克族自治旗</dataInfo>
          </el-row>
          <el-row>
            <dataInfo :number="24" name="产品简介" :value="str"></dataInfo>
          </el-row>
          <el-row>
            <dataInfo :number="24" name="图片">
              <el-row class="mb30">
                <div class="df jcb">
                  <el-image
                    v-for="item in yzpztp"
                    :key="item"
                    style="min-height: 140px;"
                    :style="{
                      width: 97 / yzpztp.length + '%'
                    }"
                    :src="baseUrl + item"
                    :preview-src-list="[baseUrl + item]"
                  ></el-image>
                </div>
              </el-row>
            </dataInfo>
          </el-row>
          <el-row>
            <dataInfo :number="24" name="养殖流程图">
              <el-row class="mb30">
                <el-image
                  style="width: 100%; height: 300px"
                  :src="require('@/assets/images/sy/yz_01.png')"
                  :preview-src-list="[require('@/assets/images/sy/yz_01.png')]"
                ></el-image>
              </el-row>
            </dataInfo>
          </el-row>
        </div>
        <!-- 企业信息 -->
        <div class="content" v-show="active === 2">
          <el-row>
            <dataInfo
              :number="12"
              name="企业名称"
              :value="compInfo.compMc"
            ></dataInfo>
            <dataInfo
              :number="12"
              name="负责人"
              :value="compInfo.compQyfzr"
            ></dataInfo>
          </el-row>
          <el-row>
            <dataInfo
              :number="12"
              name="联系方式"
              :value="compInfo.compQyfzrdh"
            ></dataInfo>
            <dataInfo
              :number="12"
              name="统一社会信用代码"
              :value="compInfo.compTyshxydm"
            ></dataInfo>
          </el-row>
          <el-row>
            <dataInfo
              :number="12"
              name="法人姓名"
              :value="compInfo.compFrxm"
            ></dataInfo>
            <dataInfo
              :number="12"
              name="详细地址"
              :value="compInfo.compXxdz"
            ></dataInfo>
          </el-row>
          <el-row>
            <dataInfo :number="24" name="企业介绍" :value="str1"></dataInfo>
          </el-row>
          <el-row>
            <dataInfo :number="24" name="地图">
              <baidu-map
                :center="center"
                :zoom="18"
                class="bm-view ml16 mr16"
                ak="DsYmGKO9sf2Bzg4AKFtBNzOXhIhBkZ3S"
              >
                <bm-marker :dragging="false" :position="center"> </bm-marker>
              </baidu-map>
            </dataInfo>
          </el-row>
          <el-row>
            <dataInfo :number="24" name="荣誉资质">
              <el-row class="mb30">
                <div class="df jcb">
                  <el-image
                    v-for="item in yzpztp1"
                    :key="item"
                    style="min-height: 140px;"
                    :style="{
                      width: 97 / yzpztp1.length + '%'
                    }"
                    :src="baseUrl + item"
                    :preview-src-list="[baseUrl + item]"
                  ></el-image>
                </div>
              </el-row>
            </dataInfo>
          </el-row>
        </div>
        <!-- 产地信息 -->
        <div class="content" v-show="active === 3">
          <el-row>
            <dataInfo
              :number="12"
              name="羊场名称"
              :value="origInfo.origMc"
            ></dataInfo>
            <dataInfo
              :number="12"
              name="草场面积"
              :value="origInfo.origMj + '亩'"
            ></dataInfo>
          </el-row>
          <el-row>
            <dataInfo :number="24" name="视频信息">
              <div class="df fww">
                <template v-for="item in 4">
                  <cockpitVideo
                    :style="{ width: 99 / 3 + '%' }"
                    style="flex-grow:0;flex-shrink:0;padding:5px;"
                  ></cockpitVideo>
                </template>
              </div>
            </dataInfo>
          </el-row>
        </div>
        <!-- 深度溯源 -->
        <div class="content" v-show="active === 4">
          <el-row>
            <dataInfo
              :number="12"
              name="批次号"
              :value="batchInfo.batchNum"
            ></dataInfo>
            <dataInfo
              :number="12"
              name="养殖开始日期"
              :value="kssjFmt"
            ></dataInfo>
          </el-row>
          <div class="df jcc mt20 mb20">
            <img
              class="sy"
              @click="getSdsy"
              src="@/assets/images/sy/btn_suyuan.svg"
              alt=""
            />
          </div>
        </div>
        <!-- 品质保证 -->
        <div class="content" v-show="active === 5">
          <el-row>
            <dataInfo :number="24">
              <img
                src="@/assets/images/sy/cjhg.png"
                class="mb30 pctw100"
                alt=""
              />
            </dataInfo>
          </el-row>
          <el-row>
            <dataInfo :number="8" name="抽检合格"></dataInfo>
            <dataInfo :number="8" name="委托检测合格"></dataInfo>
            <dataInfo :number="8" name="自检合格"></dataInfo>
          </el-row>
          <div class="df">
            <div class="qualified ml16">
              <span class="wrap">自我承诺合格</span>
              <div class="fg1"></div>
              <i
                class="el-icon-success"
                style="color:#449b4f;font-size:20px;"
              />
            </div>
            <div class="fg1"></div>
            <img
              class="sy"
              src="@/assets/images/sy/btn_shangcheng.svg"
              alt=""
            />
            <div class="fg1"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="right w14 fg1" v-if="showSdsy">
      <!-- 顶部tab栏 -->
      <div class="searchInfo" style="justify-content: flex-start;height:89px">
        <el-page-header
          @back="showSdsy = !showSdsy"
          content="深度溯源"
          style="margin-left:30px"
        >
        </el-page-header>
      </div>

      <div class="ova mb30" style="border-radius:0px 0px 10px 10px;">
        <!-- 深度溯源 -->
        <div class="content">
          <sdsy v-if="showSdsy"></sdsy>
        </div>
      </div>
    </div>
    <div class="searchMask" v-show="show">
      <img src="../../../assets/images/sy/load.gif" class="gif" alt="" />
      <img src="../../../assets/images/sy/slogan.svg" class="slogan" alt="" />
    </div>
  </div>
</template>

<script>
import BaiduMap from "vue-baidu-map/components/map/Map.vue";
import BmMarker from "vue-baidu-map/components/overlays/Marker";
export default {
  name: "info",
  components: {
    dataInfo: () => import("./components/info.vue"),
    BaiduMap,
    BmMarker,
    cockpitVideo: () => import("@/pages/cockpit/components/cockpitVideo.vue"),
    sdsy: () => import("./components/sdsy.vue")
  },
  data() {
    return {
      active: 1,
      center: {},
      url: "",
      show: true,
      list: [1],
      str: "",
      strFmt: "",
      times: 0,
      isLoaded: false,
      isShow: false,
      isTag: false,
      cpjs: "",
      qywz: "",
      address: "",
      baseUrl:
        this.getGlobalConfig().uploadURL +
        "/api/file/downloadFile?fileHashOrWholeFileId=",
      yzpztp: [],
      batchInfo: {},
      kssjFmt: "",
      origInfo: {},
      str1: "",
      strFmt1: "",
      isShow1: false,
      isTag1: false,
      compInfo: {},
      yzpztp1: [],
      showSdsy: false
    };
  },

  computed: {},

  created() {
    this.batchInfo = JSON.parse(sessionStorage.getItem("batchInfo"));
    this.kssjFmt = this.fmtDate(this.batchInfo.batchKsrq);
    this.doOrgInfo();
    this.doCompInfo();
    this.doProdInfo();
    setTimeout(() => {
      this.show = false;
    }, 2000);
  },

  methods: {
    getSdsy() {
      this.showSdsy = true;
    },
    fmtDate(kssj) {
      if (kssj) {
        let date = new Date(kssj);
        return (
          date.getFullYear() +
          "-" +
          (date.getMonth() + 1) +
          "-" +
          date.getDate()
        );
      }
      return "";
    },
    doProdInfo() {
      let params = {
        scriptId: "dp06001",
        prodId: JSON.parse(sessionStorage.getItem("batchInfo")).prodId,
        compId: JSON.parse(sessionStorage.getItem("batchInfo")).compId
      };
      this.$api
        .formPost("/api/financing/fd/scriptRule/openQuery", params)
        .then(res => {
          if (res.retHead.code == "0000000") {
            let prodInfo = res.retBody.retList[0];
            if (prodInfo.prodCpjs) {
              this.strFmt = prodInfo.prodCpjs;
            }
            if (prodInfo.prodCpjs == undefined || prodInfo.prodCpjs == "") {
              this.isTag = true;
            }
            if (prodInfo.prodCpjs && prodInfo.prodCpjs.length > 6) {
              this.isShow = true;
              this.strFmt = prodInfo.prodCpjs.substring(0, 6);
            }
            this.str = prodInfo.prodCpjs;
            this.cpjs = prodInfo.prodPp;
            this.qywz = prodInfo.gfwzdz;
            //产品图片
            if (prodInfo.tpdzs) {
              this.yzpztp = prodInfo.tpdzs.split(",");
            }
          }
        });
    },
    doCompInfo() {
      let params = {
        scriptId: "dp06002",
        compId: JSON.parse(sessionStorage.getItem("batchInfo")).compId
      };
      this.$api
        .formPost("/api/financing/fd/scriptRule/openQuery", params)
        .then(res => {
          if (res.retHead.code == "0000000") {
            if (res.retBody.retList[0]) {
              this.compInfo = res.retBody.retList[0];
              if (this.compInfo.compInfoQyjs) {
                this.strFmt1 = this.compInfo.compInfoQyjs;
              }
              if (
                this.compInfo.compInfoQyjs == undefined ||
                this.compInfo.compInfoQyjs == ""
              ) {
                this.isTag1 = true;
              }
              if (
                this.compInfo.compInfoQyjs &&
                this.compInfo.compInfoQyjs.length > 6
              ) {
                this.isShow1 = true;
                this.strFmt1 = this.compInfo.compInfoQyjs.substring(0, 6);
              }
              this.str1 = this.compInfo.compInfoQyjs;
              //地图 经纬度
              let arrList = this.compInfo.compJwd.split(",");
              if (arrList) {
                //将列表中的字符串改为数字类型
                let arr = arrList.map(Number);
                this.center.lat = arr[0];
                this.center.lng = arr[1];
              }
              // 图片 以,隔开
              if (this.compInfo.tpdzs) {
                this.yzpztp1 = this.compInfo.tpdzs.split(",");
              }
            }
          }
        });
    },
    doOrgInfo() {
      let params = {
        scriptId: "dp06003",
        origId: JSON.parse(sessionStorage.getItem("batchInfo")).batchCdIds
      };
      this.$api
        .formPost("/api/financing/fd/scriptRule/openQuery", params)
        .then(res => {
          if (res.retHead.code == "0000000") {
            if (res.retBody.retList[0]) {
              this.origInfo = res.retBody.retList[0];
              //设备视频地址
              //this.origInfo.devSpdz
            }
          }
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.info {
  height: 100vh;
  width: 100vw;
  background: url("../../../assets/images/sy/bg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  display: flex;
  overflow: hidden;

  .left {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .bg {
      background: url("../../../assets/images/sy/sheep.jpg");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      height: 26.042vw;
      width: 32.292vw;
      display: flex;
      justify-content: center;
      align-items: center;
      box-shadow: 0px 0px 20px 0px rgba(255, 255, 255, 0.2);
      border-radius: 10px;

      .code {
        height: 60px;
        line-height: 60px;
        font-size: 32px;
        padding: 0px 20px;
        border-radius: 10px;
        color: #fff;
        background: rgba(0, 0, 0, 0.6);
      }
    }
  }

  .right {
    display: flex;
    flex-direction: column;
    padding-right: 7.813vw;

    .searchInfo {
      margin-top: 50px;
      background: #b4b4b4;
      border-radius: 10px 10px 0px 0px;
      display: flex;
      justify-content: space-around;
      align-items: center;
      .tab {
        flex-grow: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        cursor: pointer;

        img {
          height: 36px;
          margin-top: 20px;
        }

        div {
          font-size: 16px;
          color: #333;
          line-height: 28px;
          margin-bottom: 5px;
        }
      }

      .active {
        background: #fff !important;

        div {
          color: #449b4f !important;
        }
      }
    }

    .content {
      background: #fff;
      padding: 2.083vw;
      border-radius: 0px 0px 10px 10px;
    }
  }
}

.bm-view {
  height: 300px;
}

.info {
  scrollbar-width: 0px;
  scrollbar-base-color: #449b4f !important;
  scrollbar-highlight-color: #449b4f !important;
}

/*滚动条整体部分,必须要设置*/
.info ::-webkit-scrollbar {
  width: 0px;
  height: 0px;
  background-color: #449b4f !important;

  cursor: pointer;
}

.sy {
  cursor: pointer;
}

.jcc {
  justify-content: center;
}

.qualified {
  display: flex;
  height: 30px;
  background: rgba(68, 155, 79, 0.2);
  border-radius: 12px;
  line-height: 30px;
  padding: 0px 7px 0px 12px;
  align-items: center;
  width: 165px;
  margin-top: 16px;

  .wrap {
    font-size: 18px;
    font-weight: 400;
    color: #449b4f;
    line-height: 20px;
  }
}

.searchMask {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background: #fff;

  .gif {
    height: 26.563vw;
    width: 26.563vw;
    margin-bottom: 5vw;
  }
}
.fww {
  flex-wrap: wrap;
}
/deep/ .el-page-header__title {
  font-size: 20px;
}
/deep/ .el-page-header__left .el-icon-back {
  font-size: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/sy/info/index.vue